// extracted by mini-css-extract-plugin
export var bounce = "_of-1";
export var generatingText = "_of-6";
export var lightning = "_of-4";
export var popup = "_of-5";
export var progressBar = "_of-7";
export var progressFill = "_of-8";
export var progressShimmer = "_of-9";
export var progressText = "_of-a";
export var shimmer = "_of-3";
export var uploadIcon = "_of-0";
export var uploadingText = "_of-2";